import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-2 pr-2 text-xs" }
const _hoisted_2 = { class: "flex items-center mb-10" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "w-16 h-16 overflow-hidden border rounded-full" }
const _hoisted_5 = { class: "mx-2" }
const _hoisted_6 = { class: "text-sm font-semibold" }
const _hoisted_7 = { class: "text-gray-400" }
const _hoisted_8 = {
  key: 0,
  class: "flex items-center justify-center w-10 h-10 transform rotate-45 bg-red-500 rounded-full"
}
const _hoisted_9 = {
  key: 1,
  class: "flex items-center justify-center w-10 h-10 transform -rotate-45 bg-green-500 rounded-full"
}
const _hoisted_10 = {
  key: 2,
  class: "flex items-center justify-center w-10 h-10 bg-yellow-500 rounded-full"
}
const _hoisted_11 = {
  key: 3,
  class: "flex items-center justify-center w-10 h-10 bg-gray-500 rounded-full"
}
const _hoisted_12 = {
  key: 0,
  class: "pl-2"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "text-xs text-right" }, "Relative Rank and Course", -1)
const _hoisted_14 = { class: "flex flex-row justify-between" }
const _hoisted_15 = { class: "pl-12" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "text-center" }, "Accelerate", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "text-center" }, "Decelerate", -1)
const _hoisted_19 = {
  key: 1,
  class: "mt-4 bg-primary-dark"
}
const _hoisted_20 = {
  key: 2,
  class: "text-right"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")
  const _component_trending_chart = _resolveComponent("trending-chart")
  const _component_zero_landing_component = _resolveComponent("zero-landing-component")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("img", {
            src: _ctx.student.photoUrl,
            alt: _ctx.student.firstName
          }, null, 8, ["src", "alt"])
        ])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, _toDisplayString(_ctx.student.firstName) + " " + _toDisplayString(_ctx.student.lastName), 1),
        _createVNode("div", _hoisted_7, _toDisplayString(_ctx.courseLabel), 1)
      ]),
      _createVNode("div", null, [
        (_ctx.trendDirection === 'down')
          ? (_openBlock(), _createBlock("div", _hoisted_8, [
              _createVNode(_component_fa, {
                icon: "arrow-right",
                type: "fas",
                height: "20"
              })
            ]))
          : (_ctx.trendDirection === 'up')
            ? (_openBlock(), _createBlock("div", _hoisted_9, [
                _createVNode(_component_fa, {
                  icon: "arrow-right",
                  type: "fas",
                  height: "20"
                })
              ]))
            : (_ctx.trendDirection === 'right')
              ? (_openBlock(), _createBlock("div", _hoisted_10, [
                  _createVNode(_component_fa, {
                    icon: "arrow-right",
                    type: "fas",
                    height: "20"
                  })
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_11, [
                  _createVNode(_component_fa, {
                    icon: "times",
                    type: "fas",
                    height: "20"
                  })
                ]))
      ]),
      (_ctx.chartData && _ctx.chartData.rank_course)
        ? (_openBlock(), _createBlock("div", _hoisted_12, [
            _hoisted_13,
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.relativeRankCourse, (data, index) => {
              return (_openBlock(), _createBlock("div", {
                key: index,
                class: "text-right text-xxs"
              }, [
                _createVNode("div", _hoisted_14, [
                  _createVNode("div", _hoisted_15, _toDisplayString(data.placement), 1),
                  _createVNode("div", null, _toDisplayString(data.follow_on_course), 1)
                ])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.chartData)
      ? (_openBlock(), _createBlock("div", _hoisted_16, [
          _hoisted_17,
          _createVNode(_component_trending_chart, {
            "data-testid": `student-${_ctx.student.id}-trending-card`,
            chartData: _ctx.chartData,
            studentId: _ctx.student.id
          }, null, 8, ["data-testid", "chartData", "studentId"]),
          _hoisted_18
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_19, [
          _createVNode(_component_zero_landing_component, {
            "data-testid": `student-${_ctx.student.id}-missing-historical-data`,
            message: "No historical student data available"
          }, null, 8, ["data-testid"])
        ])),
    (_ctx.latestRidesRemaining != -1)
      ? (_openBlock(), _createBlock("div", _hoisted_20, " Rides Remaining: " + _toDisplayString(_ctx.latestRidesRemaining), 1))
      : _createCommentVNode("", true)
  ]))
}